import * as FileSaver from 'file-saver';

import { TeacherApplicationContext } from '~shared/context/TeacherApplicationContext';

import platform from '../../../../shared/Platform';
import axios from '../../src/api/localAxios';
import { get } from '../shared/utils/Request';

function getFilenameFromResponse(response) {
  let contentDisposition = '';

  if (response && response.headers && response.headers['content-disposition']) {
    contentDisposition = response.headers['content-disposition'];
  }
  contentDisposition = decodeURI(contentDisposition);
  contentDisposition = contentDisposition.split(';')[1];
  const keyMatch = 'filename=';
  const startIndex = contentDisposition.indexOf(keyMatch) + keyMatch.length;
  const filename = contentDisposition.substring(
    startIndex,
    contentDisposition.length
  );
  return filename.replace(/"/g, '');
}

export function downloadReportToDevice(url: string) {
  let isOlderIOS = false;
  if (platform.iosVersion) {
    try {
      let iosVersion = platform.iosVersion.split('.')[0];
      iosVersion = +iosVersion;
      if (iosVersion < 13) {
        isOlderIOS = true;
      }
    } catch (err) {
      console.error('Failed to determine ios version', err);
      isOlderIOS = true;
    }
  }

  if (isOlderIOS) {
    // Use an iFrame for older iOS download
    const hiddenIframeId = 'reportDownloader';
    let iframe: any = document.getElementById(hiddenIframeId);
    if (iframe === null) {
      iframe = document.createElement('iframe');
      iframe.id = hiddenIframeId;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
    }
    iframe.src = url;
  } else if (platform.isWrapperApp()) {
    window.open(url, '_self');
  } else {
    // For newer Operating systems user file saver
    get(url, { responseType: 'blob' }).then((response) => {
      const filename = getFilenameFromResponse(response);
      FileSaver.saveAs(response['data'], filename);
    });
  }
}

export function pollForDownloadReady({
  pollingUrl,
  timeout = 1500,
  onPollComplete = () => {},
  onPollError = () => {},
  appContext = TeacherApplicationContext.Socrative,
}: {
  pollingUrl: string;
  timeout?: number;
  onPollComplete?: (url: string) => void;
  onPollError?: (error: any) => void;
  appContext?: TeacherApplicationContext;
}) {
  const polling = setTimeout(() => {
    axios
      .get(pollingUrl)
      .then((response) => {
        const data = response['data'];
        if (data['url']) {
          // File is ready to download
          onPollComplete(data['url']);

          // Download the report directly only for Socrative
          if (appContext === TeacherApplicationContext.Socrative) {
            downloadReportToDevice(data['url']);
          }

          clearTimeout(polling);
        } else {
          // Continue polling but increase the time
          pollForDownloadReady({
            pollingUrl,
            timeout: timeout + 500,
            onPollComplete,
            onPollError,
            appContext,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        onPollError(error);
      });
  }, timeout);
}
